import { http } from 'lib/services/http';

const DEPARTMENT_API_PATH = '/v3/table-metas/department/data';

export const getEmails = () => {
  const params = {
    include: 'email_channel',
    fields: {
      department: 'id,name,email_channel',
      emailchannel: 'email,active,is_default',
    },
    page: {
      size: '100',
    },
  };

  return http.get(DEPARTMENT_API_PATH, { params });
};
